module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Pompeii.96ac69b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Pompeii.jpg
// module id = k1g9
// module chunks = 0